import api from "./apiClient";

/* ===================================================== */
/* 🔧 ERROR NORMALIZER                                   */
/* ===================================================== */

function normalizeError(err, fallbackMessage) {
  return new Error(
    err?.response?.data?.message ||
    err?.message ||
    fallbackMessage
  );
}

/* ===================================================== */
/* 📦 RESPONSE NORMALIZER                                */
/* Handles { task } vs direct object                     */
/* ===================================================== */

function extractTask(data) {
  if (!data) return null;
  return data.task || data;
}

/* ===================================================== */
/* 📥 GET PHASE TASKS                                    */
/* GET /phasetask/:projectId/phases/:phaseId/tasks       */
/* ===================================================== */

export const getPhaseTasks = async (
  projectId,
  phaseId,
  filters = {}
) => {
  if (!projectId || !phaseId) {
    throw new Error("projectId and phaseId are required");
  }

  try {
    const { data } = await api.get(
      `/phasetask/${projectId}/phases/${phaseId}/tasks`,
      { params: filters }
    );

    return Array.isArray(data) ? data : [];
  } catch (err) {
    throw normalizeError(err, "Failed to fetch phase tasks");
  }
};

/* ===================================================== */
/* ➕ CREATE PHASE TASK                                  */
/* POST /phasetask/:projectId/phases/:phaseId/tasks      */
/* ===================================================== */

export const createPhaseTask = async (
  projectId,
  phaseId,
  payload = {}
) => {
  if (!projectId || !phaseId) {
    throw new Error("projectId and phaseId are required");
  }

  const title = payload?.title?.trim();

  if (!title) {
    throw new Error("Task title is required");
  }

  try {
    const { data } = await api.post(
      `/phasetask/${projectId}/phases/${phaseId}/tasks`,
      {
        ...payload,
        title,
      }
    );

    return extractTask(data);
  } catch (err) {
    throw normalizeError(err, "Failed to create phase task");
  }
};

/* ===================================================== */
/* 🔄 UPDATE PHASE TASK                                  */
/* PUT /tasks/:taskId (shared endpoint)                  */
/* ===================================================== */

export const updatePhaseTask = async (taskId, payload = {}) => {
  if (!taskId) {
    throw new Error("Task ID is required");
  }

  try {
    const { data } = await api.put(`/tasks/${taskId}`, payload);
    return extractTask(data);
  } catch (err) {
    throw normalizeError(err, "Failed to update phase task");
  }
};

/* ===================================================== */
/* 🗑 DELETE PHASE TASK                                  */
/* DELETE /tasks/:taskId                                 */
/* ===================================================== */

export const deletePhaseTask = async (taskId) => {
  if (!taskId) {
    throw new Error("Task ID is required");
  }

  try {
    await api.delete(`/tasks/${taskId}`);
    return true;
  } catch (err) {
    throw normalizeError(err, "Failed to delete phase task");
  }
};

/* ===================================================== */
/* 📦 EXPORT                                             */
/* ===================================================== */

const phaseTaskService = {
  getPhaseTasks,
  createPhaseTask,
  updatePhaseTask,
  deletePhaseTask,
};

export default phaseTaskService;